import * as React from 'react';
import { Container, Row, Col, Button } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee, faList, faBell } from '@fortawesome/free-solid-svg-icons';
import { faComments } from '@fortawesome/free-regular-svg-icons';
import { stat } from 'fs';
import 'react-notifications-component/dist/theme.css';
import MessageBoard from "./messageBoardList";
import MessageBoardDetails from "./messageBoardDetail";
import Reports from "./report";
import Topics from "./topic";
import Posts from "./post";
import { Capitalize, showAlert } from '../common/functions';

class MessageBoardPageComponent extends React.Component {

	state = {
		isView: false,
		page: "",
		id: -1,
		title: "",
		code: "",
		status:""
	}
	constructor(props: any) {
		super(props);
		this.state = {
			isView: false,
			page: "",
			id: -1,
			title: "",
			code: "",
			status: ""
		}
		this.handleCallBackMethod = this.handleCallBackMethod.bind(this);
	}

	componentDidMount() {

		var tokenstr = (new URLSearchParams(window.location.search))?.get("page");
		var tValue = tokenstr === null ? "" : tokenstr
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var id = idstr === null ? -1 : parseInt(idstr);
		var codestr = (new URLSearchParams(window.location.search)).get("code");
		var codeValue = codestr === null ? "" : codestr;

		var pageValue = ((tValue === null && id >= 0)) ? "detail" : tValue;
		this.setState({
			...stat,
			page: pageValue,
			id: id,
			code: codeValue,
			isView: pageValue === "" ? true : false
		});
				
		var alertMessage = window.localStorage.getItem('alertMessage');
		if (alertMessage && alertMessage !== "") {
			showAlert(alertMessage, false);
			window.localStorage.setItem('alertMessage', "");
		}
		var title = ""
		if (tokenstr === 'topics') {
			if (id > 0 && codestr == null) {
				title = Capitalize(tokenstr)
			} else {
				title = codestr ?
					codestr === "support" ? "Support and Feedback" : Capitalize(codestr) : "Message Boards"
			}
		} else if (tokenstr === 'detail' || tokenstr==='add') {
			title = "Message Board"
		} else if (tokenstr === 'alerts' || tokenstr === 'posts' || tokenstr === 'reports') {
			title = Capitalize(tokenstr)
		} else if (tokenstr === 'report') {
			title = "Alerts"
		}
		else {
			title = "Message Boards"
		}

		document.title = `${title} - Daily Audio Bible Administration`;
	}

	handleCallBackMethod(value, status) {
		this.setState({ title: value, status:status });
	}

	render() {
		const { title } = this.state;
		return (
			<div>
				<Container>
					<Row>
						<Col lg="12">
							{this.state.page == "add" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faCoffee} />
										<span data-testid="messageBoardPageTitle"> {title} </span>
									</h2>
									<hr />
									<MessageBoardDetails callback={this.handleCallBackMethod} id={this.state.id} />
								</div>
							)}
							{this.state.page == "detail" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faCoffee} />
										<span data-testid="messageBoardPageTitle"> {Capitalize(title)} </span>
									</h2>
									<hr />
									<MessageBoardDetails callback={this.handleCallBackMethod} id={this.state.id} />
								</div>
							)}
							{this.state.page == "reports" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faCoffee} />
										<span data-testid="messageBoardPageTitle"> {Capitalize(title)} - Stats</span>
									</h2>
									<hr />
									<Reports callback={this.handleCallBackMethod} id={this.state.id} />
								</div>
							)}
							{this.state.page == "topics" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faList} />
										<span data-testid="messageBoardPageTitle"> {Capitalize(title)}</span>
									</h2>
									<hr />
									<Topics id={this.state.id} code={this.state.code} callback={this.handleCallBackMethod} />
								</div>
							)}
							{(this.state.page == "posts") && (
								<div>
									<h2 className="post-title">
										<span>
											<FontAwesomeIcon icon={faComments} />
											<span data-testid="messageBoardPageTitle" className={this.state.status ? "post-deleted" : ""}>  {Capitalize(title)}</span>
										</span>
										{this.state.status && <label>deleted</label>}
									</h2>									
									<hr />
									<Posts callback={this.handleCallBackMethod} id={this.state.id} />
								</div>
							)}
							{(this.state.page == "alerts" || this.state.page == "report") && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faBell} />
										<span data-testid="messageBoardPageTitle"> {Capitalize(title)} - Alerts</span>
									</h2>
									<hr />
									<Posts callback={this.handleCallBackMethod} id={this.state.id} />
								</div>
							)}							
							{this.state.page == "" && this.state.isView && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faCoffee} />
										<span data-testid="messageBoardPageTitle"> Message Boards</span>
									</h2>
									<hr />
									<MessageBoard />
								</div>
							)}
						</Col>
						<Col />
					</Row>
				</Container>
			</div>
		);
	}
}

export default MessageBoardPageComponent;